export const MicrosoftGraphScopes = ['User.read']
export const MicrosoftGraphBaseURL = 'https://graph.microsoft.com/v1.0'
export const MicrosoftGraphEndpoints = {
	me: '/me',
	group: '/me/memberOf',
	photo: '/me/photos'
}
